<!DOCTYPE html>
<!--
	TODO:
		left pane navigation (use components if possible)
			Admin (target 20200712)
				Create users (see Register)
					- Partially done, migrate to use Firebase Admin + FCF
				(using Admin SDK+FCF) Disable user
			Encoders (target 20200718)
				Create entry (metadata)
					- Company Name
					- data - map
					- dateCreated
					- userId
					- type -> to follow for purpose
		main content
			Admin
				list of users (activate/deactivate)
					- list OK
					- activate/deactivate - to follow
			Encoders
				list of entries made by userId
-->
<template>
	<main id="main-content" class="container py-4">
		<div id="professional-docs">
			<div class="d-flex justify-content-between align-items-center mb-2">
				<h2 class="mb-0">My Documents</h2>
				<div class="d-flex align-items-center">
					<label for="doc-per-page" class="mr-2 mb-0 small text-muted">Show:</label>
					<b-form-select id="doc-per-page" v-model="docMetadataPerPage" :options="perPageOptions" size="sm" style="width:auto"/>
				</div>
			</div>
			<b-table id="doc_table" striped hover responsive
				:items="docMetadataList"
				:fields="docFields"
				:per-page="docMetadataPerPage"
				:current-page="docMetadataCurrentPage"
				show-empty
				empty-text="No documents yet."
				@row-clicked="viewDocumentMetadata">
			</b-table>
			<b-pagination
				v-model="docMetadataCurrentPage"
				:total-rows="docMetadataRows"
				:per-page="docMetadataPerPage"
				aria-controls="doc_table" align="center">
			</b-pagination>
		</div>
		<div id="financialStatementSets" class="mt-4">
			<div class="d-flex justify-content-between align-items-center mb-2">
				<h2 class="mb-0">Financial Statement Sets</h2>
				<div class="d-flex align-items-center">
					<label for="fsset-per-page" class="mr-2 mb-0 small text-muted">Show:</label>
					<b-form-select id="fsset-per-page" v-model="fsSetPerPage" :options="perPageOptions" size="sm" style="width:auto"/>
				</div>
			</div>
			<b-table id="fsSet_table" striped hover responsive
				:items="fsSetList"
				:fields="fsSetFields"
				:per-page="fsSetPerPage"
				:current-page="fsSetCurrentPage"
				show-empty
				empty-text="No financial statement sets yet."
				@row-clicked="viewFinancialStatementSet">
			</b-table>
			<b-pagination
				v-model="fsSetCurrentPage"
				:total-rows="fsSetsRows"
				:per-page="fsSetPerPage"
				aria-controls="fsSet_table" align="center">
			</b-pagination>
		</div>
		<div id="metadata_info" class="modal">
			<b-modal ref="metadata_info" :title="modalTitle" ok-only size="lg">
				<view-doc :uid="modalUid" :key="modalUid"/>
			</b-modal>
		</div>
	</main>
</template>
<style lang="scss" scoped>
</style>
<script>
	import firebase from "firebase/compat/app";
	import "firebase/compat/auth";
	import "firebase/compat/firestore";
	import ViewDocument from "@/components/view-document";
	
	class Document {
		constructor() {
		
		}
	}
	class FinancialStatementSet {
		constructor() {
		
		}
	}
	export default {
		methods: {
			getUsersDocuments: async function() {
				//TODO: create onSnapshotChange of collection updates from components
				//in progress
				this.docMetadataList = [];
				firebase.firestore().collection("Documents")
					.doc(firebase.auth().currentUser.uid).get().then(userDocument => {
						userDocument.ref.collection("Metadata").orderBy("createdDate", "desc")
						.get().then(metadataSnapshot => {
							metadataSnapshot.forEach(metadataDocSnapshot => {
								var metadata = metadataDocSnapshot.data();
								var document = new Document();
								document.uid = metadataDocSnapshot.id;
								document.companyName = metadata.companyName;
								document.createdDate = metadata.createdDate.toDate().toLocaleDateString("en-US");
								
								this.docMetadataList.push(document);
							});
						});
					});
			},
			getUsersFinancialStatementSets: async function() {
				this.fsSetList = [];
				firebase.firestore().collection("FinancialStatementSet")
					.orderBy("createdDate", "desc")
					.where("uploadedBy", "==", firebase.auth().currentUser.uid)
					.get()
					.then(financialStatementSets => {
						financialStatementSets.forEach(fsSetSnapshot => {
							var data = fsSetSnapshot.data();
							var fsSet = new FinancialStatementSet();
							fsSet.id = fsSetSnapshot.id;
							fsSet.documentName = data.documentName;
							fsSet.createdDate = data.createdDate.toDate().toLocaleDateString("en-US");
							
							this.fsSetList.push(fsSet);
						});
					});
			},
			viewDocumentMetadata: function(document, index) {
				this.modalUid = document.uid;
				this.modalTitle = document.companyName || 'Document Details';
				this.$refs["metadata_info"].show();
			},
			viewFinancialStatementSet: function(fsSet, index) {
				this.$router.push({name: "view-fs-set", params: {id: fsSet.id}});
			}
		},
		mounted() {
			this.getUsersDocuments();
			this.getUsersFinancialStatementSets();
		},
		components: {'view-doc': ViewDocument},
		data() {
			return {
				uid: "",
				firstName: "",
				middleName: "",
				lastName: "",
				birthdate: null,
				fullAddress: "",
				prcId: "",
				email: "",
				password: "",
				confirmPassword: "",
				role: -1,
				error: "",
				
				
				docMetadataList: [],
				docFields: [
					{ key: 'companyName', label: 'Company Name', sortable: true },
					{ key: 'createdDate', label: 'Date Created', sortable: true }
				],
				companyName: "",
				data: {},
				data_key: "",
				data_value: "",

				docMetadataPerPage: 10,
				docMetadataCurrentPage: 1,

				perPageOptions: [10, 20, 50],

				fsSetList: [],
				fsSetFields: [
					{ key: 'documentName', label: 'Document Name', sortable: true },
					{ key: 'createdDate', label: 'Date Uploaded', sortable: true }
				],
				fsSetPerPage: 10,
				fsSetCurrentPage: 1,

				modalUid: null,
				modalTitle: 'Document Details',
			}
		},
		computed: {
			docMetadataRows() {
				return this.docMetadataList.length;
			},
			fsSetsRows() {
				return this.fsSetList.length;
			}

		}
	}
</script>

